import styled from 'styled-components';
import { getCellSize } from '../../../../../Chip/chipsFormats';

interface Props {
  chipsFormat: string;
  isOver: boolean;
  itemIsSelected: boolean;
}

export const StyledUnOrderedDropZone = styled.div<Props>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-height: 0;
  flex-wrap: wrap;
  align-items: center;
  min-height: auto;
  max-width: 800px;
  display: grid;
  grid-template-columns: repeat(auto-fit, ${props => getCellSize(props.chipsFormat)});
  grid-gap: 4px;
  align-content: center;
  padding: 40px;
  border-radius: 12px;
  cursor: ${props => props.itemIsSelected ? 'pointer' : 'auto'};
  background-color: ${props => props.isOver ? 'rgba(243, 247, 246, .8)' : 'transparent'};
  
  &:hover {
    background-color: ${props => props.itemIsSelected  ? 'rgba(243, 247, 246, .8)' : 'none'};
  }
  @media (min-width: 1000px) { grid-gap: 20px; }
`;